import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Toggle dropdown for mobile
  const toggleDropdown = (dropdownName) => {
    if (isMobile) {
      setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    }
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">Mahen Mahindaratne</Link>
      </div>
      
      <ul className="links">
        <li>
          <Link to="/">Home</Link>
        </li>

        {/* Microeconomics Dropdown */}
        <li 
          className="dropdown"
          onClick={() => toggleDropdown("micro")}
        >
          <span>
            Microeconomics <i className="bx bxs-chevron-down"></i>
          </span>
          <ul className={`sub-menu ${isMobile && activeDropdown === "micro" ? "active" : ""}`}>
            <li>
              <Link to="/introduction-to-economics">Introduction to Economics</Link>
            </li>
            <li>
              <Link to="/demand-and-supply">Demand and Supply</Link>
            </li>
            <li>
              <Link to="/elasticity">Elasticity</Link>
            </li>
            <li>
              <Link to="/utility">Utility</Link>
            </li>
            <li>
              <Link to="/cost-structure">The Cost Structure of Firms</Link>
            </li>
            <li>
              <Link to="/markets-firms">Markets and Firms</Link>
            </li>
            <li>
              <Link to="/labor-market">The Labor Market</Link>
            </li>
            <li>
              <Link to="/government-intervention">Government Intervention and the Role of the Government</Link>
            </li>
          </ul>
        </li>

        <li 
          className="dropdown"
          onClick={() => toggleDropdown("macro")}
        >
          <span>
            Macroeconomics <i className="bx bxs-chevron-down"></i>
          </span>
          <ul className={`sub-menu ${isMobile && activeDropdown === "macro" ? "active" : ""}`}>
            <li>
              <Link to="/gdp">Gross Domestic Product</Link>
            </li>
            <li>
              <Link to="/money-and-monetary-institutions">Money and Monetary Institutions</Link>
            </li>
            <li>
              <Link to="/credible-inflation-targeting">Credible Inflation Targeting</Link>
            </li>
          </ul>
        </li>

        {/* Commercial Law Dropdown */}
        <li 
          className="dropdown"
          onClick={() => toggleDropdown("comm")}
        >
          <span>
            Commercial Law <i className="bx bxs-chevron-down"></i>
          </span>
          <ul className={`sub-menu ${isMobile && activeDropdown === "comm" ? "active" : ""}`}>
            <li>
              <Link to="/comm_1">The Importance of Non Disclosure Agreements</Link>
              <Link to="/comm_2">Due Diligence: What it is, and why it is necessary</Link>
              <Link to="/comm_3">Business Sale/Puchase vs. Asset Sale/Purchase vs. Share Sale/Purchase</Link>
              <Link to="/comm_4">Whitewash Transactions: How Liquidity Tests, Resolutions, and Filings Prevent Abuse</Link>
              <Link to="/comm_5">The Importance of MAC Clauses and Their Role in Strengthening Force Majeure Provisions</Link>
            </li>
          </ul>
        </li>

        {/* Corporate Finance Dropdown */}
        <li 
          className="dropdown"
          onClick={() => toggleDropdown("finance")}
        >
          <span>
            Corporate Finance <i className="bx bxs-chevron-down"></i>
          </span>
          <ul className={`sub-menu ${isMobile && activeDropdown === "finance" ? "active" : ""}`}>
            <li>
              <Link to="/absolute-vauluation-models">Absolute Valuation Models</Link>
            </li>
            <li>
              <Link to="/wacc">Weighted Average Cost of Capital (WACC)</Link>
            </li>
            <li>
              <Link to="/capm">Capital Asset Pricing Model (CAPM) and Beta</Link>
            </li>
            <li>
              <Link to="/gaussian-copular-function">Understanding the Gaussian Copula Function</Link>
            </li>
            <li>
              <Link to="/irr_mirr">The Internal Rate of Return and the Modified Internal Rate of Return</Link>
            </li>
          </ul>
        </li>

        {/* Mathematics Dropdown */}
        <li 
          className="dropdown"
          onClick={() => toggleDropdown("math")}
        >
          <span>
            Mathematics <i className="bx bxs-chevron-down"></i>
          </span>
          <ul className={`sub-menu ${isMobile && activeDropdown === "math" ? "active" : ""}`}>
            <li>
              <Link to="/math">Core Mathematic Modules</Link>
            </li>
          </ul>
        </li>

      </ul>
    </nav>
  );
};

export default Navbar;